export const studioCalendarFr = {
  'Single Timeline': 'Planning unique',
  'Multi-Room Timeline': 'Planning multi-salle',
  'Day Off': 'Jour de repos',
  'Outside Hours': 'Hors horaires',
  'Booked': 'Réservé',
  'Legend': 'Légende',
  'Engineer Availability': 'Disponibilité des ingénieurs',
  // Récurrence
  'Repeat this booking': 'Répéter ce rendez-vous',
  'Every week': 'Chaque semaine',
  'Every 2 weeks': 'Toutes les 2 semaines',
  'Every month': 'Chaque mois',
  'Frequency': 'Fréquence',
  'After': 'Après',
  'sessions': 'séances',
  'Until': "Jusqu'au",
  '{{count}} bookings will be created': '{{count}} réservations seront créées',
  'Total for series': 'Total pour la série',
  'Create {{count}} Bookings': 'Créer {{count}} réservations',
  '{{count}} bookings created successfully': '{{count}} réservations créées avec succès',
  // Replanification
  'Confirm Reschedule': 'Confirmer le déplacement',
  'From': 'De',
  'To': 'À',
  'The customer will be notified of this time change.': 'Le client sera notifié de ce changement d\'horaire.',
  'Booking rescheduled successfully': 'Réservation déplacée avec succès',
  'Failed to reschedule booking': 'Échec du déplacement de la réservation',
  'Move': 'Déplacer',
  'Move Mode': 'Mode déplacement',
  'Switch to view mode': 'Revenir au mode consultation',
  'Switch to move mode — drag bookings to reschedule': 'Activer le mode déplacement — glissez les réservations pour les déplacer',
};
